import React, { useState, useRef } from "react";

const questions = [
  {
    title: (
      <>
        <span className="font-bold">
          Obtain and review the following original company documents
        </span>
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: <span className="font-bold">Registration certificate</span>,
    uploads: [
      "Attach copy of document here (pdf , .Jpeg)",
      "Attach copy of document here (pdf , .Jpeg)",
    ],
  },
  {
    title: (
      <>
        <span className="font-bold">Memorandum of Incorporation,</span> Articles, Founding Statement, Amended Founding Statement, and Shareholders Agreement
      </>
    ),
    uploads: [
      "Attach copy of document here (pdf , .Jpeg)",
      "Attach copy of document here (pdf , .Jpeg)",
    ],
  },
  {
    title: (
      <>
        <span className="font-bold">Directors and Shareholder Register</span> (not applicable to listed companies)
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">Confirm that all statutory requirements </span>
        governing the conduct of the business and company are up to date and have been complied with.
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">Confirm that all statutory requirements </span>
        governing the conduct of the business and company are up to date and have been complied with.
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">Is the transaction envisaged provided </span>
        for in the Memorandum of Incorporation of the company?
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">Particulars of share capital, showing </span>
        authorised and issued capital and classes of shares, copies of any agreement or commitment to create, issue or transfer shares (including loans and share options)
      </>
    ),
    uploads: ["Attach copy of register", "Attach copy of register"],
  },
];

const OptionButton = ({ label, selected, onClick }) => (
  <div className="flex flex-col items-center space-y-2 md:space-y-5">
    <span className="text-[8px] md:text-[24px] font-medium">{label}</span>
    <button
      onClick={onClick}
      className={`w-[20px] h-[20px] md:w-[53px] md:h-[53px] rounded-full transition
        ${selected ? 'bg-[#03897B] border-[3px] md:border-[8px] border-white' : 'bg-transparent border-[6px] md:border-[8px] border-white'}
      `}
    ></button>
  </div>
);

const UploadBox = ({ text, image, onImageChange }) => {
  const inputRef = useRef();

  const handleClick = () => {
    inputRef.current.click();
  };

  return (
    <div
      className="w-[40px] md:w-[182px] h-full mx-1 md:mx-12 bg-[#E7EBEB] rounded-[5px] p-2 md:p-4 text-[6px] md:text-[18px] leading-snug relative flex items-center justify-center overflow-hidden"
    >
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={onImageChange}
        style={{ display: "none" }}
      />
      <div
        onClick={handleClick}
        className="absolute top-1 right-2 text-[5px] md:text-[24px] cursor-pointer z-10"
      >
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746028067/Add_square_ztbsgd.png"
          alt="Add"
          className="w-[10px] md:w-[34px]"
        />
      </div>
      {image ? (
        <img
          src={URL.createObjectURL(image)}
          alt="Uploaded"
          className="w-full h-full object-cover rounded-[5px]"
        />
      ) : (
        <p className="absolute bottom-10 md:bottom-12 p-4">{text}</p>
      )}
    </div>
  );
};

export default function LegalDueDiligenceChecklist() {
  const [responses, setResponses] = useState({});
  const [uploads, setUploads] = useState({});

  const handleSelect = (index, value) => {
    setResponses({ ...responses, [index]: value });
  };

  const handleUploadChange = (questionIndex, uploadIndex, file) => {
    setUploads((prev) => ({
      ...prev,
      [questionIndex]: {
        ...(prev[questionIndex] || {}),
        [uploadIndex]: file,
      },
    }));
  };

  return (
    <div className="space-y-4 ">
      <div className="leading-[1.2] text-center">
        <h2 className="text-[10px] md:text-[28px] font-bold text-[#03897B]">
          LEGAL DUE DILIGENCE CHECK LIST
        </h2>
        <p className="text-[10px] md:text-[24px] font-normal">
          To be completed by funding applicant
        </p>
      </div>

      <div className="h-2 md:h-5" />

      <div>
<div className="flex justify-between ">
<h2 className="text-[10px] md:text-[24px] font-bold text-[#03897B]">
      ENTERPRENEUR
        </h2>
        <h1 className="md:text-[24px] text-[8px] font-bold text-black md:pr-40">ID NO: XXXXXXXX01</h1>
</div>
        <h2 className="text-[8px] md:text-[24px] font-bold text-[#03897B] -mb-3 mt-5 ">
          <span className="text-[#979797]">Section 1 : </span>LEGAL
        </h2>
      </div>

      {questions.map((q, i) => (
        <div
          key={i}
          className="flex space-x-2 h-[100px] md:h-[233px] md:min-w-[700px]"
        >
          {/* Left: Question */}
          <div className="w-[100px] md:w-[390px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] inline leading-[1.2]">
            {q.title}
          </div>

          {/* Middle: Y / N / NA Buttons */}
          {["Y", "N", "NA"].map((opt) => (
            <div
              key={opt}
              className="w-[40px] md:w-[100px] bg-[#E7EBEB] rounded-[5px] flex justify-center items-center md:pb-16"
            >
              <OptionButton
                label={opt}
                selected={responses[i] === opt}
                onClick={() => handleSelect(i, opt)}
              />
            </div>
          ))}

          {/* Right: Comment or Upload Boxes */}
          {q.comment ? (
            <div className="w-[100px] md:w-[500px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] flex">
              {q.comment}
            </div>
          ) : (
            <div className="flex space-x-1 md:-space-x-5">
              {q.uploads?.map((text, idx) => (
                <UploadBox
                  key={idx}
                  text={text}
                  image={uploads[i]?.[idx]}
                  onImageChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      handleUploadChange(i, idx, file);
                    }
                  }}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
